export const addDailyPrefix = (isDailyRentPage, originPath) => {
  return `${isDailyRentPage ? "/الحجز-اليومي" : ""}${originPath}`;
};

export const addPrefix = ({ isMapPage, isDailyRentPage, originPath }) => {
  if (!isMapPage) return addDailyPrefix(isDailyRentPage, originPath);
  return `${isDailyRentPage ? "/daily-map" : "/map"}${originPath}`;
};

export const getDailyRentQuery = (isDailyRentPage, query) => {
  return {
    ...(isDailyRentPage && query?.day_date ? { day_date: query.day_date } : {}),
  };
};
